import Vue from 'vue'
function getLanguage(key,defaultValue) {
  let langPacks=window.$languagePacks || {};
  let s= langPacks[key] || defaultValue || key;
  if(s && s.indexOf && s.indexOf("{")>=0){
    let values=Array.prototype.slice.call(arguments,2);
    let defaultIndex=0;
    s=s.replace(/\{(\d)?\}/g,function(s,i){
      if(i===undefined){
        i=defaultIndex;
      }
      defaultIndex++;
      return values[i];
    })
  }
  return s
}

window.$lang=getLanguage;
Vue.prototype.$lang=getLanguage;
export default getLanguage;



// WEBPACK FOOTER //
// ./src/common/utils/multiLang.js